"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _best_buys = require("@/api/goods_activity/best_buys");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BestBuysTablePane',
  components: {},
  data: function data() {
    return {
      loading: false,
      tableKey: 0,
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
        keywords: ''
      }
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    handleEdit: function handleEdit(row) {
      this.$emit('editActivity', row.fnId);
    },
    addActivity: function addActivity() {
      this.$emit('addActivity');
    },
    handleToggleEnable: function handleToggleEnable(row) {
      var _this = this;
      (0, _best_buys.toggleEnable)(row.fnId, row.markForEnable).then(function () {
        _this.$message.success('状态修改成功');
      }).catch(function () {
        // 失败时恢复原状态
        row.markForEnable = !row.markForEnable;
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.search();
    },
    search: function search() {
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleFilter: function handleFilter() {
      var _this2 = this;
      this.loading = true;
      (0, _best_buys.bestBuysPage)(this.listQuery).then(function (res) {
        _this2.tableData = res.records;
        _this2.total = res.total;
        _this2.loading = false;
      }, function () {
        _this2.loading = false;
      });
    }
  }
};